import { render, staticRenderFns } from "./WishListForm.vue?vue&type=template&id=216f03fe&scoped=true"
import script from "./WishListForm.vue?vue&type=script&lang=js"
export * from "./WishListForm.vue?vue&type=script&lang=js"
import style0 from "./WishListForm.vue?vue&type=style&index=0&id=216f03fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216f03fe",
  null
  
)

export default component.exports